import { Pipe, PipeTransform } from '@angular/core';
import { normalizeString } from '@timechef/core/utils/string-utils';
import { Category } from '@timechef/features/faq/state/faq.models';

@Pipe({
  name: 'faqFilter',
  standalone: false,
})
export class FaqFilterPipe implements PipeTransform {
  /**
   * https://dev.to/idrisrampurawala/creating-a-search-filter-in-angular-562d
   * Pipe filters the list of elements based on the search text provided
   *
   * @param items list of elements to search in
   * @param searchText search string
   * @returns list of elements filtered by search text or []
   */
  transform(items: Category[], searchText: string | null | undefined): Category[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = normalizeString(searchText);

    return items.map((categorie) => {
      return {
        ...categorie,
        questions: categorie.questions.filter((faqQuestion) => {
          if (normalizeString(faqQuestion.answer).includes(searchText!) || normalizeString(faqQuestion.question).includes(searchText!)) return faqQuestion;

          return;
        }),
      };
    });
  }
}
